import { Component, input, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatChipsModule } from '@angular/material/chips';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'facet-chips',
  imports: [CommonModule, MatChipsModule, NgbTooltip],
  templateUrl: './facet-chips.component.html',
  styleUrls: ['./facet-chips.component.scss']
})
export class FacetChipsComponent {
  displayedFacets = input<string[][]>([]);
  showAllFacets = signal<boolean>(false);
  
  tooltipLabel(key: string): string {
    switch (key) {
      case 'lifecycle':
        return 'Lifecycle Phase';
      case 'persona':
        return 'Persona';
      case 'tooltype':
        return 'Tool Type';
      default:
        return '';
    }
  }
  
  toggleShowAllFacets(): void {
    this.showAllFacets.update(value => !value);
  }
}
